export default "__VITE_ASSET__CmjMb2Vk__"